(function () {
    "use strict";

    document.addEventListener("DOMContentLoaded", function () {
        initMobileMenu();
        initRevealAnimations();
    });

    function initMobileMenu() {
        var toggle = document.getElementById("menu-toggle");
        var menu = document.getElementById("mobile-menu");

        if (!toggle || !menu) {
            return;
        }

        var openLabel = "Abrir menu";
        var closeLabel = "Fechar menu";

        function setOpen(isOpen) {
            toggle.classList.toggle("is-open", isOpen);
            menu.classList.toggle("is-open", isOpen);
            document.body.classList.toggle("menu-open", isOpen);
            toggle.setAttribute("aria-expanded", isOpen ? "true" : "false");
            toggle.setAttribute("aria-label", isOpen ? closeLabel : openLabel);
            menu.setAttribute("aria-hidden", isOpen ? "false" : "true");
        }

        toggle.addEventListener("click", function () {
            var willOpen = !menu.classList.contains("is-open");
            setOpen(willOpen);
        });

        var links = menu.querySelectorAll("a");
        links.forEach(function (link) {
            link.addEventListener("click", function () {
                setOpen(false);
            });
        });

        document.addEventListener("keydown", function (event) {
            if (event.key === "Escape" && menu.classList.contains("is-open")) {
                setOpen(false);
            }
        });
    }

    function initRevealAnimations() {
        var elements = document.querySelectorAll(".reveal");

        if (elements.length === 0) {
            return;
        }

        if (!("IntersectionObserver" in window)) {
            elements.forEach(function (el) {
                el.classList.add("is-visible");
            });
            return;
        }

        var observer = new IntersectionObserver(
            function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("is-visible");
                        observer.unobserve(entry.target);
                    }
                });
            },
            {
                threshold: 0.12,
                rootMargin: "0px 0px -60px 0px",
            },
        );

        elements.forEach(function (el) {
            observer.observe(el);
        });
    }
})();
